export const images = {
  hero: 'https://cdn.magicpatterns.com/patterns/generated-images/6063068f-1c83-4375-bb59-74da4448c8d7.jpg',
  portrait:
    'https://cdn.magicpatterns.com/patterns/generated-images/b2afeea2-d06a-4bc9-a4fe-b4a97fca198a.jpg',
  abstract:
    'https://cdn.magicpatterns.com/patterns/generated-images/e31e9805-3d0c-45cc-a4c8-32c70dd852ee.jpg',
  team: 'https://cdn.magicpatterns.com/patterns/generated-images/471dd63c-4fe4-4c0a-a48b-61864004a1b5.jpg',
  architecture:
    'https://cdn.magicpatterns.com/patterns/generated-images/0ed598b2-6763-43b5-8afa-16ffca93cdc7.jpg',
}

export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
]

export const pillars = [
  {
    title: 'Built for clarity',
    body: 'Legal services should be easier to understand, from first conversation to final document.',
  },
  {
    title: 'Built for efficiency',
    body: 'Technology removes friction, so work moves faster without losing care.',
  },
  {
    title: 'Built for trust',
    body: 'Lawyers remain at the centre of every matter, with review and judgment throughout.',
  },
  {
    title: 'Built for access',
    body: 'A modern legal model can make professional help more approachable.',
  },
]

export const steps = [
  {
    title: 'Understand',
    body: 'We start by understanding the legal issue and what outcome matters to you.',
  },
  {
    title: 'Prepare',
    body: 'Technology helps organize information and prepare the matter with structure.',
  },
  {
    title: 'Review',
    body: 'Lawyers review, advise, and guide the legal work from beginning to end.',
  },
  {
    title: 'Deliver',
    body: 'You receive a clear, professional legal solution you can act on.',
  },
]

export const processFlow = [
  {
    title: 'Intake and issue identification',
    body: 'A short, structured intake clarifies the situation and the legal question behind it.',
  },
  {
    title: 'Information and document organization',
    body: 'Facts, dates, and documents are gathered into one organized record of the matter.',
  },
  {
    title: 'AI-assisted preparation',
    body: 'AI drafts structure, surfaces relevant details, and prepares the groundwork for review.',
  },
  {
    title: 'Lawyer review',
    body: 'A lawyer reviews the work, applies professional judgment, and shapes the advice.',
  },
  {
    title: 'Final legal output',
    body: 'The finished document or guidance is delivered, explained in plain language.',
  },
]

export const serviceCategories = [
  {
    id: 'business',
    title: 'Business & Corporate',
    intro: 'Practical support for founders and growing companies.',
    items: [
      'Incorporations',
      'Founder agreements',
      'Commercial contracts',
      'Corporate maintenance',
      'Privacy and compliance',
    ],
  },
  {
    id: 'individuals',
    title: 'Individuals & Families',
    intro: 'Personal legal matters handled with care and clarity.',
    items: [
      'Wills',
      'Powers of attorney',
      'Cohabitation agreements',
      'Separation agreements',
      'Estate-related matters',
    ],
  },
  {
    id: 'property',
    title: 'Property & Real Estate',
    intro: 'Clear answers on the agreements behind where you live and work.',
    items: [
      'Lease reviews',
      'Residential lease issues',
      'Commercial lease matters',
      'Real estate-related agreements',
    ],
  },
  {
    id: 'disputes',
    title: 'Disputes & Protection',
    intro: 'Measured steps when something needs to be resolved.',
    items: [
      'Demand letters',
      'Settlement agreements',
      'Small claims preparation',
      'Contract disputes',
    ],
  },
]

export const jurisdictions = [
  { province: 'Ontario', firm: 'Lena Vartanian Law Firm' },
  { province: 'Québec', firm: 'Lexo Legal Inc.' },
]

/** Regulatory disclosure shown sitewide. */
export const legalDisclosure =
  'All legal services are provided by lawyers who are members of their respective law societies. In Ontario, legal services are provided by Lena Vartanian Law Firm. In Québec, legal services are provided by Lexo Legal Inc.'

export const principles = [
  {
    title: 'Clarity',
    body: 'Plain language, defined scope, and a clear view of where a matter stands.',
  },
  {
    title: 'Efficiency',
    body: 'Structured workflows and technology that reduce the time between question and answer.',
  },
  {
    title: 'Professional oversight',
    body: 'Licensed lawyers review the work and remain accountable for the advice.',
  },
  {
    title: 'Innovation with responsibility',
    body: 'New tools are adopted deliberately, with confidentiality and duty of care first.',
  },
]
